/*
 * Posterstrecke (26.10.2026, PLAN-2026-10-26-POSTERSTRECKE.md).
 *
 * Telefon zuerst, drei Schritte wie die Buchstrecke (Paul 27.10.): 1 Foto
 * hochladen mit Vorname, Kind, Alter und Mailadresse, 2 Vorschau (davor das
 * Warten mit Prozent), 3 Bestellen mit Groesse und Rahmen, dann Warenkorb und
 * Kasse. Kopf, Felder und "Deine Angaben" aus der Buchstrecke, Foto, Warten
 * und Wand nach dem Paket design_handoff_wunolo_posterfunnel (Claude Design).
 * Das Skript zeichnet seine Oberflaeche
 * selbst in #wunolo-poster-funnel; der Abschnitt im Theme
 * (sections/wunolo-poster-funnel.liquid) liefert nur window.WUNOLO_POSTER.
 * Dieselbe Datei laeuft lokal in public/poster.html gegen den Testserver.
 *
 * Uebernommen aus der Buchstrecke (assets/wunolo-funnel.js), weil dort am
 * Telefon erprobt:
 *   - geduldig: Serverneustart abwarten statt Fehlermeldung (bis 6 Minuten)
 *   - Nachfragepfad: Das iPhone bricht lange Anfragen nach gut 30 s ab, der
 *     Server rechnet weiter. Ohne Serverantwort fragt die Strecke den
 *     Auftrag nach, statt einen Fehler zu zeigen.
 *   - Foto vor dem Hochladen auf 1600 px verkleinern
 *   - Turnstile ueber Cloudflares onload-Rueckruf (window.turnstile ist auf
 *     wunolo.de schon belegt)
 *   - Messung ohne Cookies, Meta-Kennungen nur mit Einwilligung
 */
(function () {
  'use strict'
  const D = window.WUNOLO_POSTER || {}
  const BACKEND = window.WUNOLO_BACKEND || ''
  const wurzel = document.getElementById('wunolo-poster-funnel')
  if (!wurzel || !D.motiv) return

  // ------------------------------------------------------------ Zustand
  const SPEICHER = 'wunolo.poster.' + D.motiv
  const state = {
    schritt: 'foto',
    jobId: null,
    name: '',
    gender: null, // 'girl' oder 'boy', wie in der Buchstrecke
    ageRange: null, // '2-3', '4-5', '6-7', '8+'
    mail: '', // freiwillig, geht mit dem Auftrag an den Server
    foto: null,
    fotoUrl: null,
    einwilligung: false,
    turnstileToken: null,
    poster: null, // Antwort des Servers: posterUrl, posterNr, posterVarianten, posterVersucheUebrig
    gewaehlt: null, // Nummer der Variante, die in den Korb geht
    variante: null, // Shopify-Variante (Groesse)
    groesseGewaehlt: false, // erst dann steht die Groesse in "Deine Angaben"
    rahmen: null, // 'schwarz', 'weiss', 'eiche' oder null (ohne Rahmen)
    fotoFehler: null, // { titel, text }, wenn der Server das Foto ablehnt
    fotoGeprueft: false, // erst dann "Gesicht gut zu sehen"
    abbruch: false, // Verbindung abgerissen, "Nochmal versuchen"
    wartenSeit: null,
    laeuft: false
  }
  const varianten = (D.varianten || []).filter(v => v && v.id)
  const startId = Number(new URLSearchParams(location.search).get('variante'))
  state.variante = varianten.find(v => v.id === startId) || varianten[0] || null

  // ------------------------------------------------------------ Messung
  const MESS_SITZUNG = (() => { try { return crypto.randomUUID().slice(0, 16) } catch { return Math.random().toString(36).slice(2, 14) } })()
  const MESS_TEST = (() => {
    try {
      const p = new URLSearchParams(location.search).get('messung')
      if (p === 'test') localStorage.setItem('wunolo-messung-test', '1')
      if (p === 'echt') localStorage.removeItem('wunolo-messung-test')
      return localStorage.getItem('wunolo-messung-test') === '1'
    } catch { return false }
  })()
  const MESS_ANZEIGE = new URLSearchParams(location.search).get('utm_content') || undefined
  const geraet = () => (window.innerWidth < 768 ? 'mobil' : 'desktop')
  const umgebung = (() => {
    const ua = navigator.userAgent || ''
    return {
      browser: /Instagram/i.test(ua) ? 'instagram' : /FBAN|FBAV|FB_IAB/i.test(ua) ? 'facebook' : 'andere',
      system: /iPhone|iPad|iPod/i.test(ua) ? 'ios' : /Android/i.test(ua) ? 'android' : 'andere'
    }
  })()
  const gemeldet = new Set()
  const WIEDERHOLBAR = new Set(['foto_abgelehnt', 'figur_neu'])
  function messe (ereignis, extra = {}) {
    if (!WIEDERHOLBAR.has(ereignis) && gemeldet.has(ereignis)) return
    gemeldet.add(ereignis)
    const daten = { sitzung: MESS_SITZUNG, ereignis, quelle: 'poster', storyId: 'poster-' + D.motiv, geraet: geraet(), test: MESS_TEST, anzeige: MESS_ANZEIGE, browser: umgebung.browser, system: umgebung.system, ...extra }
    try {
      const ziel = BACKEND + '/api/messung'
      const koerper = JSON.stringify(daten)
      if (navigator.sendBeacon) navigator.sendBeacon(ziel, new Blob([koerper], { type: 'text/plain;charset=UTF-8' }))
      else fetch(ziel, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: koerper, keepalive: true }).catch(() => {})
    } catch { /* eine verlorene Messung ist folgenlos */ }
  }
  const messKennung = () => ({ sitzung: MESS_SITZUNG, test: MESS_TEST, geraet: geraet(), anzeige: MESS_ANZEIGE, browser: umgebung.browser, system: umgebung.system })

  function metaKennungen () {
    const privacy = window.Shopify && window.Shopify.customerPrivacy
    const erlaubt = Boolean(privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed())
    if (!erlaubt) return { einwilligung: false }
    const cookie = n => (document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')) || [])[1] || null
    let fbc = cookie('_fbc')
    const fbclid = new URLSearchParams(location.search).get('fbclid')
    if (!fbc && fbclid) fbc = 'fb.1.' + Date.now() + '.' + fbclid
    return { einwilligung: true, fbp: cookie('_fbp'), fbc, ttp: cookie('_ttp'), ttclid: new URLSearchParams(location.search).get('ttclid') || null, url: location.href.split('#')[0], von: 'poster' }
  }
  try {
    const sh = window.Shopify
    if (sh && typeof sh.loadFeatures === 'function' && !(sh.customerPrivacy && sh.customerPrivacy.marketingAllowed)) {
      sh.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {})
    }
  } catch { /* ohne Einwilligungs-API keine Meta-Meldung, mehr nicht */ }

  // ------------------------------------------------------------ Netz
  const NEUSTART_GEDULD_MS = 360000
  async function serverAntwortet () {
    try {
      const res = await fetch(BACKEND + '/health', { cache: 'no-store', signal: AbortSignal.timeout ? AbortSignal.timeout(5000) : undefined })
      return res.ok
    } catch { return false }
  }
  async function istNeustartAntwort (res) {
    if (![502, 503, 504].includes(res.status)) return false
    const daten = await res.clone().json().catch(() => null)
    return !(daten && typeof daten.error === 'string')
  }
  async function geduldig (anfrage) {
    const ende = Date.now() + NEUSTART_GEDULD_MS
    let warte = 1500
    for (;;) {
      try {
        const res = await anfrage()
        if (Date.now() > ende || !(await istNeustartAntwort(res))) return res
      } catch (err) {
        if (err?.name === 'AbortError' || err?.name === 'TimeoutError' || Date.now() > ende || await serverAntwortet()) throw err
      }
      await new Promise(r => setTimeout(r, warte))
      warte = Math.min(warte * 1.5, 6000)
    }
  }
  // vomServer: Der Server hat geantwortet (Fehlertext lesen); sonst ist die
  // Verbindung abgerissen, und der Nachfragepfad holt das Ergebnis.
  async function api (pfad, { methode = 'POST', json, roh, typ } = {}) {
    const res = await geduldig(() => fetch(BACKEND + pfad, {
      method: methode,
      headers: roh ? { 'Content-Type': typ || 'image/jpeg' } : json ? { 'Content-Type': 'application/json' } : {},
      body: roh || (json ? JSON.stringify(json) : undefined)
    }))
    const daten = await res.json().catch(() => ({}))
    if (!res.ok) {
      const e = new Error(daten.error || 'Fehler ' + res.status)
      e.vomServer = true
      e.status = res.status
      e.code = daten.code || null
      throw e
    }
    return daten
  }
  const holeAuftrag = id => fetch(BACKEND + '/api/jobs/' + encodeURIComponent(id) + '?t=' + Date.now(), { cache: 'no-store' }).then(r => r.ok ? r.json() : null).catch(() => null)
  const bildUrl = pfad => (pfad && pfad.startsWith('/') ? BACKEND + pfad : pfad)

  // ------------------------------------------------------------ Foto
  const FOTO_KANTE = 1600
  function ladeBild (file) {
    const ueberElement = () => new Promise((ok, nein) => {
      const url = URL.createObjectURL(file)
      const img = new Image()
      img.onload = () => { URL.revokeObjectURL(url); ok(img) }
      img.onerror = () => { URL.revokeObjectURL(url); nein(new Error('Bild nicht lesbar')) }
      img.src = url
    })
    return typeof createImageBitmap === 'function' ? createImageBitmap(file).catch(ueberElement) : ueberElement()
  }
  async function verkleinereFoto (file) {
    let bild = null
    try {
      bild = await ladeBild(file)
      const b = bild.width || bild.naturalWidth
      const h = bild.height || bild.naturalHeight
      if (!b || !h) return file
      const f = Math.min(1, FOTO_KANTE / Math.max(b, h))
      if (f === 1 && ['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) return file
      const c = document.createElement('canvas')
      c.width = Math.round(b * f)
      c.height = Math.round(h * f)
      c.getContext('2d').drawImage(bild, 0, 0, c.width, c.height)
      return (await new Promise(r => c.toBlob(r, 'image/jpeg', 0.85))) || file
    } catch { return file } finally { if (bild && typeof bild.close === 'function') bild.close() }
  }

  // ------------------------------------------------------------ Turnstile
  function turnstileSitekey () {
    try {
      const probe = new URLSearchParams(location.search).get('turnstile')
      if (probe && /^0x[A-Za-z0-9_-]{10,}$/.test(probe)) return probe
    } catch {}
    return window.WUNOLO_TURNSTILE_SITEKEY || ''
  }
  let turnstileGestartet = false
  function initTurnstile () {
    const sitekey = turnstileSitekey()
    if (!sitekey || turnstileGestartet) return
    turnstileGestartet = true
    let gerendert = false
    const zeichnen = () => {
      if (gerendert) return true
      if (typeof window.turnstile?.render !== 'function' || !document.getElementById('wpf-turnstile')) return false
      gerendert = true
      window.turnstile.render('#wpf-turnstile', {
        sitekey,
        callback: t => { state.turnstileToken = t; pruefeKnopf() },
        'expired-callback': () => { state.turnstileToken = null; pruefeKnopf() },
        'error-callback': () => { state.turnstileToken = null; pruefeKnopf() }
      })
      return true
    }
    window.wunoloTurnstileBereit = () => { zeichnen() }
    if (!zeichnen() && !document.querySelector('script[src*="turnstile/v0/api.js"][data-wunolo]')) {
      const s = document.createElement('script')
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=wunoloTurnstileBereit'
      s.async = true
      s.dataset.wunolo = '1'
      document.head.appendChild(s)
    }
    let n = 0
    const takt = setInterval(() => { n++; if (zeichnen() || n > 40) clearInterval(takt) }, 500)
  }
  const turnstileNoetig = () => Boolean(turnstileSitekey())


  // ------------------------------------------------------------ Hilfen
  const $ = s => wurzel.querySelector(s)
  const esc = t => String(t == null ? '' : t).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))
  const vorname = () => state.name.trim()
  // Genitiv wie genitivName im Server: Lottas, Max’
  const genitiv = n => /[sßxz]$/i.test(n) ? n + '’' : n + 's'
  const posterVon = () => (vorname() ? genitiv(vorname()) + ' Poster' : 'Dein Poster')
  const euro = n => Number(n || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
  const formatVon = v => (v && /50\s*x\s*70/.test(v.titel) ? '50x70' : '30x40')
  const istMail = s => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(s || '').trim())
  // Umrisse im gleichen Massstab (Design 27.10.: 1,16 px je cm)
  const UMRISS = { '30x40': [35, 46], '50x70': [58, 81] }
  // Wie in der Buchstrecke (wunolo-funnel.js): Anzeige und Altersspannen
  const GESCHLECHT = { girl: 'Mädchen', boy: 'Junge' }
  const ALTER = [['3', '2-3'], ['5', '4-5'], ['7', '6-7'], ['9', '8+']]

  // Rahmen (C6, 27.10.2026): aus dem Abschnitt, Schluessel Format und Farbe
  // aus der SKU (FF-RA-30x40-eiche). Ohne kaufbares Rahmenprodukt entfaellt
  // der Schritt ganz.
  const FARBEN = { schwarz: { name: 'Schwarz', ton: '#24272E' }, weiss: { name: 'Weiß', ton: '#FFFFFF' }, eiche: { name: 'Eiche', ton: '#C9A36B' } }
  const rahmenVarianten = (D.rahmen || []).filter(r => r && r.id && FARBEN[r.farbe])
  const rahmenFuer = (farbe, v = state.variante) => rahmenVarianten.find(r => r.farbe === farbe && r.groesse === formatVon(v)) || null

  function merken () {
    try { sessionStorage.setItem(SPEICHER, JSON.stringify({ jobId: state.jobId, name: state.name, gender: state.gender, ageRange: state.ageRange, mail: state.mail, gewaehlt: state.gewaehlt, variante: state.variante && state.variante.id, rahmen: state.rahmen })) } catch {}
  }

  // ------------------------------------------------------------ Oberflaeche
  // Aufmachung der Buchstrecke (Paul 27.10.: "warum orientieren wir uns nicht
  // ... an dem, was wir schon haben, wenn wir ein Buch kreieren?"): Kopf mit
  // Ziffern-Stepper und Schliessen-X, Kickerzeile "Schritt 1 von 3 · ...",
  // dieselben Felder wie dort und "Deine Angaben" als Zusammenfassung. Die
  // Klassen fk-*, step, field, choice kommen aus wunolo-styles.css (Buch),
  // die wpf-* aus wunolo-poster-funnel.css (Foto, Warten, Poster, Wahl).
  const alterKnoepfe = ALTER.map(([wert, spanne]) => `<button class="choice" type="button" data-alter="${spanne}" data-wert="${wert}" aria-pressed="false">${spanne}</button>`).join('')
  wurzel.innerHTML = `
    <header class="fk-kopf">
      <div class="fk-kopf-innen">
        <nav class="fk-stepper" id="wpf-stepper" aria-label="Fortschritt"></nav>
        <div class="fk-kopf-rechts">
          <span class="fk-vertrauen">Kostenlose Vorschau, du entscheidest danach</span>
          <a class="fk-schliessen" href="${esc(D.produktUrl || '/')}" title="Schließen" aria-label="Schließen">&times;</a>
        </div>
      </div>
      <div class="fk-balken"><i id="wpf-kopfbalken"></i></div>
    </header>
    <div class="fk-buehne">
      <div class="funnel wpf">
        <section class="step wpf-schritt" data-schritt="foto">
          <p class="fk-kicker">Schritt 1 von 3 · Foto hochladen</p>
          <h1>Wer kommt aufs Poster?</h1>
          <p class="lede">Wähle ein Foto deines Kindes. Du siehst das Poster kostenlos, bevor du bestellst.</p>
          <input id="wpf-datei" type="file" accept="image/*" hidden>
          <div id="wpf-foto"></div>
          <div class="wpf-tipps"><span>Gesicht von vorn</span><span>Allein im Bild</span><span>Bei Tageslicht</span></div>
          <div class="fk-felder wpf-felder">
            <label class="field"><span>Vorname</span>
              <input type="text" id="wpf-name" maxlength="30" placeholder="z. B. Mia" autocomplete="off"></label>
            <div class="field"><span>Kind</span>
              <div class="choice-grid" id="wpf-gender">
                <button class="choice" type="button" data-gender="girl" aria-pressed="false">Mädchen</button>
                <button class="choice" type="button" data-gender="boy" aria-pressed="false">Junge</button>
              </div>
            </div>
            <div class="field"><span>Alter</span>
              <div class="choice-grid" id="wpf-alter">${alterKnoepfe}</div>
            </div>
          </div>
          <div class="fk-merken-mail wpf-mail">
            <h3>E-Mail-Adresse (optional)</h3>
            <div class="fk-sichern-zeile">
              <input type="email" id="wpf-mail" placeholder="deine@mailadresse.de" autocomplete="email" inputmode="email" aria-label="Mailadresse">
            </div>
            <p class="fk-merken-dazu">Wir speichern dein Poster und schicken dir den Link, falls du später weitermachen willst.</p>
          </div>
          <label class="wpf-einwilligung" for="wpf-ok">
            <input type="checkbox" id="wpf-ok">
            <span class="wpf-kaestchen" aria-hidden="true"></span>
            <span>Ich darf dieses Foto verwenden und bin einverstanden, dass daraus das Poster mit meinem Kind entsteht. Das Foto wird danach gelöscht.</span>
          </label>
          <div id="wpf-turnstile"></div>
          <p class="wpf-fehler" id="wpf-fehler-foto" role="alert" hidden></p>
          <p class="wpf-rueckweg"><a class="fk-rueckweg" href="${esc(D.produktUrl || '/')}">← Zurück zur Produktseite</a></p>
        </section>

        <section class="step wpf-schritt" data-schritt="warten">
          <p class="fk-kicker">Schritt 2 von 3 · Vorschau</p>
          <div class="wpf-warten">
            <div class="wpf-druck wpf-warten-druck" id="wpf-warten-druck">
              <div class="wpf-warten-bild">${D.bild ? `<img id="wpf-warten-img" src="${esc(D.bild)}" alt="">` : ''}<div class="wpf-warten-schleier" id="wpf-schleier"></div></div>
            </div>
            <h2 class="wpf-warten-titel" id="wpf-warten-titel">Dein Poster entsteht</h2>
            <p class="wpf-satz wpf-warten-satz" id="wpf-warten-satz">Das dauert etwa 20 Sekunden.</p>
            <div class="wpf-fortschrittszeile">
              <div class="wpf-prozentzeile">
                <span class="wpf-phase-kurz" id="wpf-phase-kurz">Schritt 1 von 3</span>
                <span class="wpf-prozent" id="wpf-prozent-feld" aria-hidden="true"><span id="wpf-prozent">0</span><small> %</small></span>
              </div>
              <div class="wpf-balken" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" id="wpf-balken-rahmen"><span id="wpf-balken"></span></div>
            </div>
            <ol class="wpf-phasen" id="wpf-phasen"></ol>
            <p class="wpf-klein" id="wpf-warten-klein">Du kannst die Seite offen lassen, wir sind gleich so weit.</p>
          </div>
        </section>

        <section class="step wpf-schritt wpf-vorschau" data-schritt="vorschau">
          <p class="fk-kicker">Schritt 2 von 3 · Vorschau</p>
          <h1 id="wpf-vorschau-titel">Dein Poster</h1>
          <p class="lede" id="wpf-vorschau-satz"></p>
          <div class="wpf-druck wpf-vorschau-druck"><img id="wpf-poster" alt="Dein Poster"></div>
          <div class="wpf-varianten" id="wpf-varianten" hidden></div>
          <p class="wpf-neu-zeile">Soll es ein anderes Foto sein? <button type="button" class="wpf-neu" id="wpf-anderes-foto">Neues Foto hochladen</button></p>
        </section>

        <section class="step wpf-schritt wpf-bestellen" data-schritt="bestellen">
          <p class="fk-kicker">Schritt 3 von 3 · Bestellen</p>
          <h1>Größe und Rahmen</h1>
          <p class="lede" id="wpf-bestellen-satz">Wähle, wie groß das Poster an der Wand hängen soll.</p>
          <div class="wpf-wand">
            <div class="wpf-rahmen" id="wpf-rahmen"><div class="wpf-rahmen-bild"><img id="wpf-wandbild" alt=""></div></div>
            <span class="wpf-wand-text" id="wpf-wand-text"></span>
          </div>
          <p class="wpf-ueber">Größe</p>
          <div class="wpf-groessen" role="radiogroup" aria-label="Größe" id="wpf-groessen"></div>
          <p class="wpf-hinweis">Umrisse im gleichen Maßstab</p>
          <div class="wpf-rahmenblock" id="wpf-rahmenblock" hidden>
            <p class="wpf-ueber">Rahmen</p>
            <div class="wpf-rahmenwahl" role="radiogroup" aria-label="Rahmen" id="wpf-rahmenwahl"></div>
            <p class="wpf-hinweis">Echtholz mit Acrylglas. Der Rahmen kommt flach mit, das Poster setzt ihr zu Hause ein.</p>
          </div>
          <p class="wpf-pflicht">inkl. MwSt. · zzgl. Versand · gedruckt in Deutschland</p>
          <p class="wpf-fehler" id="wpf-fehler-vorschau" role="alert" hidden></p>
        </section>
      </div>

      <aside class="fk-zusammenfassung" id="wpf-zf">
        <button class="fk-zf-schalter" id="wpf-zf-schalter" type="button" aria-expanded="false" aria-controls="wpf-zf-koerper">
          <span>Deine Angaben</span><span class="fk-zf-pfeil" aria-hidden="true"></span>
        </button>
        <div class="fk-zf-koerper" id="wpf-zf-koerper">
          <div class="fk-zf-kopf">
            ${D.bild ? `<img src="${esc(D.bild)}" alt="" width="64" height="84">` : ''}
            <div>
              <strong>${esc(D.titel)}</strong>
              <small>Poster mit deinem Kind</small>
            </div>
          </div>
          <dl class="fk-zf-zeilen">
            <div><dt>Kind</dt><dd id="wpf-zf-kind">noch offen</dd></div>
            <div><dt>Foto</dt><dd id="wpf-zf-foto">noch offen</dd></div>
            <div><dt>Größe</dt><dd id="wpf-zf-groesse">noch offen</dd></div>
            <div id="wpf-zf-rahmen-zeile" hidden><dt>Rahmen</dt><dd id="wpf-zf-rahmen">noch offen</dd></div>
            <div class="fk-zf-preis"><dt>Preis</dt><dd id="wpf-zf-preis"></dd></div>
          </dl>
          <p class="fk-zf-steuer">inkl. MwSt., zzgl. <a href="/policies/shipping-policy" target="_blank" rel="noopener">Versand</a></p>
          <ul class="fk-zf-fuss">
            <li>Kostenlose Vorschau vor dem Kauf</li>
            <li>Gedruckt in Deutschland</li>
            <li>Foto wird nach der Erstellung gelöscht</li>
          </ul>
        </div>
      </aside>
    </div>

    <div class="wpf-leiste">
      <div class="wpf-leiste-innen">
        <span class="wpf-leiste-hinweis" id="wpf-leiste-hinweis"></span>
        <span class="wpf-leiste-preis" id="wpf-leiste-preis" hidden><span id="wpf-leiste-was"></span><b id="wpf-leiste-betrag"></b></span>
        <button type="button" class="wpf-knopf" id="wpf-weiter" disabled>Poster erstellen</button>
      </div>
    </div>`

  const knopf = $('#wpf-weiter')
  document.body.classList.add('wpf-mit-leiste')
  const SCHRITTE = [['foto', 'Foto'], ['vorschau', 'Vorschau'], ['bestellen', 'Bestellen']]
  // Warten gehoert zur Vorschau, wie das Zeichnen im Buch zur Figur.
  const schrittNr = s => (s === 'warten' ? 1 : Math.max(0, SCHRITTE.findIndex(x => x[0] === s)))

  // Stepper wie in der Buchstrecke: erledigte Schritte mit Haken und
  // anspringbar, offene gesperrt. Waehrend das Poster entsteht, ist alles zu.
  function zeichneStepper () {
    const jetzt = schrittNr(state.schritt)
    $('#wpf-stepper').innerHTML = SCHRITTE.map(([s, name], i) => {
      const zustand = i < jetzt ? 'erledigt' : i === jetzt ? 'aktuell' : 'offen'
      const frei = zustand === 'erledigt' && !state.laeuft && state.schritt !== 'warten'
      return `<button class="fk-schritt" type="button" data-zustand="${zustand}" data-ziel="${s}" ${frei ? '' : 'disabled'} aria-current="${zustand === 'aktuell'}"><i>${zustand === 'erledigt' ? '✓' : i + 1}</i><span>${name}</span></button>`
    }).join('')
    $('#wpf-kopfbalken').style.width = ((jetzt + 1) / SCHRITTE.length * 100).toFixed(1) + '%'
  }

  // Vorschau und Bestellen bekommen je einen Verlaufseintrag (Paul 27.10.:
  // "Zurück" nach dem Erstellen fuehrte auf die Produktseite statt zum Foto).
  // Zurueck-Knopf und Wischgeste am Telefon gehen damit einen Schritt zurueck.
  function zeigeSchritt (s, { verlauf = true } = {}) {
    if (verlauf && (s === 'vorschau' || s === 'bestellen') && !(history.state && history.state.wpf === s)) {
      try { history.pushState({ wpf: s }, '') } catch {}
    }
    state.schritt = s
    wurzel.querySelectorAll('.wpf-schritt').forEach(el => {
      const an = el.dataset.schritt === s
      el.hidden = !an
      el.classList.toggle('active', an)
    })
    zeichneStepper()
    zeigeAngaben()
    pruefeKnopf()
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  // Deine Angaben: dieselbe Karte wie im Buch, Werte aus dem echten Zustand.
  // Der Preis steht erst fest, wenn eine Groesse gewaehlt ist; bis dahin "ab".
  function zeigeAngaben () {
    const setze = (id, wert) => {
      const el = $(id)
      el.textContent = wert || 'noch offen'
      el.classList.toggle('offen', !wert)
    }
    setze('#wpf-zf-kind', [vorname(), GESCHLECHT[state.gender], state.ageRange && state.ageRange + ' Jahre'].filter(Boolean).join(' · '))
    setze('#wpf-zf-foto', state.poster || state.fotoGeprueft ? '✓ hochgeladen' : state.foto ? 'gewählt' : '')
    const groesseFest = state.groesseGewaehlt
    setze('#wpf-zf-groesse', groesseFest && state.variante ? state.variante.titel : '')
    $('#wpf-zf-rahmen-zeile').hidden = !rahmenVarianten.length
    const rv = rahmenFuer(state.rahmen)
    setze('#wpf-zf-rahmen', groesseFest ? (rv ? FARBEN[rv.farbe].name : 'ohne') : '')
    const preise = varianten.map(v => v.preisZahl).filter(n => n > 0)
    $('#wpf-zf-preis').textContent = groesseFest && state.variante
      ? euro(state.variante.preisZahl + (rv ? rv.preisZahl : 0))
      : 'ab ' + euro(preise.length ? Math.min(...preise) : 0)
  }

  // Leiste: Hinweis, Preis und Knopf je Schritt (Design: "Es fehlt noch: ...").
  function pruefeKnopf () {
    const hinweis = $('#wpf-leiste-hinweis')
    const preis = $('#wpf-leiste-preis')
    const leiste = $('.wpf-leiste')
    leiste.hidden = state.schritt === 'warten' && !state.abbruch
    hinweis.hidden = state.schritt === 'bestellen' || state.schritt === 'warten'
    preis.hidden = state.schritt !== 'bestellen'
    leiste.classList.toggle('mit-preis', state.schritt === 'bestellen')
    if (state.schritt === 'foto') {
      const fehlt = []
      if (!state.foto && !state.poster) fehlt.push('Foto')
      if (!vorname()) fehlt.push('Vorname')
      if (!state.gender) fehlt.push('Kind')
      if (!state.ageRange) fehlt.push('Alter')
      if (state.fotoFehler) {
        hinweis.textContent = 'Bitte wähle ein anderes Foto.'
        knopf.textContent = 'Poster erstellen'
        knopf.disabled = true
      } else if (state.poster && !state.laeuft) {
        // Zurueck aus der Vorschau, Foto nicht getauscht: ohne neues Bild weiter.
        hinweis.textContent = fehlt.length ? 'Es fehlt noch: ' + fehlt.join(', ') : 'Dein Poster ist schon fertig. Ein anderes Foto ergibt ein neues Poster.'
        knopf.textContent = 'Weiter zur Vorschau'
        knopf.disabled = fehlt.length > 0
      } else {
        if (!state.einwilligung) fehlt.push('Einwilligung')
        const bestaetigung = turnstileNoetig() && !state.turnstileToken
        hinweis.textContent = fehlt.length ? 'Es fehlt noch: ' + fehlt.join(', ')
          : bestaetigung ? 'Bitte bestätige unten noch kurz, dass du ein Mensch bist.'
            : 'Alles da. Das Poster entsteht in etwa 20 Sekunden.'
        if (!state.laeuft) knopf.textContent = 'Poster erstellen'
        knopf.disabled = state.laeuft || fehlt.length > 0 || bestaetigung
      }
    } else if (state.schritt === 'warten') {
      knopf.textContent = 'Nochmal versuchen'
      knopf.disabled = !state.abbruch
    } else if (state.schritt === 'vorschau') {
      hinweis.textContent = 'Größe und Rahmen wählst du im nächsten Schritt.'
      knopf.textContent = 'Weiter zur Bestellung'
      knopf.disabled = !(state.poster && state.poster.posterUrl)
    } else if (state.schritt === 'bestellen') {
      const rv = rahmenFuer(state.rahmen)
      $('#wpf-leiste-was').textContent = state.variante ? state.variante.titel + (rv ? ' mit Rahmen' : '') : ''
      $('#wpf-leiste-betrag').textContent = euro((state.variante ? state.variante.preisZahl : 0) + (rv ? rv.preisZahl : 0))
      if (!state.laeuft) knopf.textContent = 'In den Warenkorb'
      knopf.disabled = state.laeuft || !(state.poster && state.poster.posterUrl && state.variante)
    }
  }

  function fehler (wo, text) {
    const el = $(wo === 'foto' ? '#wpf-fehler-foto' : '#wpf-fehler-vorschau')
    el.textContent = text || ''
    el.hidden = !text
  }

  // Fotofeld: leer (die ganze Karte ist der Knopf), gewaehlt (Foto gross)
  // oder ohne Gesicht (roter Rand und Hinweis). "Gesicht gut zu sehen" erst,
  // wenn der Server das Foto geprueft hat, nicht schon bei der Auswahl.
  function zeigeFoto () {
    const feld = $('#wpf-foto')
    if (state.fotoFehler && state.fotoUrl) {
      feld.innerHTML = `
        <div class="wpf-fotokarte wpf-fotokarte-fehler">
          <img src="${esc(state.fotoUrl)}" alt="Gewähltes Foto">
          <button type="button" class="wpf-foto-tausch wpf-foto-tausch-rot" data-foto>Anderes Foto wählen</button>
        </div>
        <div class="wpf-fotofehler" role="alert"><strong>${esc(state.fotoFehler.titel)}</strong>${esc(state.fotoFehler.text)}</div>`
    } else if (state.fotoUrl) {
      feld.innerHTML = `
        <div class="wpf-fotokarte">
          <img src="${esc(state.fotoUrl)}" alt="Gewähltes Foto">
          ${state.fotoGeprueft ? '<span class="wpf-foto-marke"><i></i>Gesicht gut zu sehen</span>' : ''}
          <button type="button" class="wpf-foto-tausch" data-foto>Anderes Foto</button>
        </div>`
    } else {
      feld.innerHTML = `
        <button type="button" class="wpf-fotoknopf" data-foto>
          <span class="wpf-plus" aria-hidden="true"></span>
          <span class="wpf-foto-titel">${state.poster ? 'Neues Foto wählen' : 'Foto deines Kindes wählen'}</span>
          <span class="wpf-foto-zeile">Aus der Galerie oder mit der Kamera</span>
          <span class="wpf-foto-pille">Foto wählen</span>
        </button>`
    }
  }

  // ------------------------------------------------------------ Warten
  let balkenTakt = null
  let langeTakt = null
  function phasenText () {
    const n = vorname()
    return [n ? 'Wir sehen uns ' + genitiv(n) + ' Gesicht an' : 'Wir sehen uns das Gesicht an', n ? 'Wir malen ' + n + ' ins Motiv' : 'Wir malen dein Kind ins Motiv', 'Letzter Feinschliff']
  }
  function zeigeProzent (p) {
    const ganz = Math.floor(p)
    $('#wpf-prozent').textContent = String(ganz)
    $('#wpf-balken').style.width = Math.max(2, p).toFixed(1) + '%'
    $('#wpf-balken-rahmen').setAttribute('aria-valuenow', String(ganz))
    // Das Bild wird mit dem Fortschritt schaerfer (Design: 16 px bei 0, 5 bei 95).
    const img = $('#wpf-warten-img')
    if (img) img.style.filter = 'blur(' + Math.max(4, 16 - p * 0.12).toFixed(1) + 'px) saturate(1.05)'
    const phase = p < 20 ? 0 : p < 80 ? 1 : 2
    if (!state.abbruch) $('#wpf-phase-kurz').textContent = 'Schritt ' + (phase + 1) + ' von 3'
    $('#wpf-phasen').innerHTML = phasenText().map((t, i) => `<li class="${i < phase ? 'fertig' : i === phase ? 'aktiv' : 'offen'}"><span class="wpf-phase-punkt">${i === phase ? '<i></i>' : ''}</span><span>${esc(t)}</span></li>`).join('')
  }
  // von und bis in Prozent: das Pruefen des Fotos fuellt die erste Phase, das
  // Zeichnen den Rest. Bis "bis" in der erwarteten Zeit, danach nur noch
  // langsam: Der Balken soll nie stehen und nie voll sein, bevor das Bild da ist.
  function warteBeginnt ({ von = 0, bis = 98, sekunden = 60 } = {}) {
    state.abbruch = false
    wurzel.classList.remove('wpf-abbruch')
    $('#wpf-warten-titel').textContent = posterVon() + ' entsteht'
    $('#wpf-warten-satz').textContent = 'Das dauert etwa 20 Sekunden.'
    const beginn = Date.now()
    clearInterval(balkenTakt)
    clearTimeout(langeTakt)
    zeigeProzent(von)
    balkenTakt = setInterval(() => {
      const t = (Date.now() - beginn) / 1000
      const spanne = bis - von
      const p = t < sekunden ? von + (t / sekunden) * spanne * 0.92 : von + spanne * (0.92 + 0.08 * (1 - Math.exp(-(t - sekunden) / 40)))
      zeigeProzent(Math.min(bis, p))
    }, 250)
    if (!state.wartenSeit) state.wartenSeit = beginn
    langeTakt = setTimeout(() => {
      if (state.schritt === 'warten' && !state.abbruch) $('#wpf-warten-satz').textContent = 'Heute dauert es etwas länger als sonst. Bleib gern hier, dein Poster ist gleich fertig.'
    }, Math.max(1000, 45000 - (Date.now() - state.wartenSeit)))
    if (state.schritt !== 'warten') zeigeSchritt('warten')
  }
  function warteEndet ({ voll = true } = {}) {
    clearInterval(balkenTakt)
    clearTimeout(langeTakt)
    state.wartenSeit = null
    if (voll) zeigeProzent(100)
  }
  // Verbindung abgerissen (Design "warten-abbruch"): Bild blass, Zahl grau,
  // in der Leiste "Nochmal versuchen". Ein laufender Lauf am Server haengt
  // sich beim zweiten Versuch an, ohne neue Bot-Pruefung.
  function zeigeAbbruch () {
    warteEndet({ voll: false })
    state.abbruch = true
    wurzel.classList.add('wpf-abbruch')
    $('#wpf-warten-titel').textContent = 'Die Verbindung ist abgerissen'
    $('#wpf-warten-satz').textContent = 'Dein Foto ist sicher bei uns. Prüfe kurz dein Internet und versuche es dann noch einmal.'
    $('#wpf-phase-kurz').textContent = 'Angehalten'
    if (state.schritt !== 'warten') zeigeSchritt('warten')
    else pruefeKnopf()
  }

  // Seite geschlossen, waehrend das Poster entsteht
  window.addEventListener('pagehide', () => { if (state.schritt === 'warten' && !state.abbruch) messe('warten_abgebrochen', { grund: 'poster' }) })

  // ------------------------------------------------------------ Ablauf
  async function auftragAnlegen () {
    if (state.jobId) return state.jobId
    const alter = ALTER.find(a => a[1] === state.ageRange)
    const d = await api('/api/jobs', {
      json: {
        posterMotiv: D.motiv, name: vorname(), gender: state.gender, age: alter ? Number(alter[0]) : undefined, ageRange: state.ageRange,
        vorabMail: istMail(state.mail) ? state.mail.trim() : undefined,
        consent: true, messung: messKennung()
      }
    })
    state.jobId = d.jobId
    merken()
    return state.jobId
  }

  async function fotoHochladen () {
    const marke = Math.random().toString(36).slice(2, 12)
    const blob = await verkleinereFoto(state.foto)
    messe('foto_start')
    let d
    try {
      d = await api('/api/jobs/' + encodeURIComponent(state.jobId) + '/photo?marke=' + marke, { roh: blob, typ: blob.type || 'image/jpeg' })
    } catch (err) {
      if (err.vomServer) throw err
      // Verbindung abgerissen: Der Server prueft zu Ende, Befund nachholen.
      d = await warteAufFotoBefund(marke)
    }
    // Poster schon im Warenkorb und neues Foto: Der Server legt einen neuen Auftrag an.
    if (d.jobId && d.jobId !== state.jobId) { state.jobId = d.jobId; state.poster = null; state.gewaehlt = null; merken() }
    if (!d.usable) { messe('foto_abgelehnt'); throw Object.assign(new Error(d.hint || 'Bitte wähl ein anderes Foto.'), { vomServer: true, foto: true }) }
    if (d.ohnePerson) { messe('foto_ohne_person'); throw Object.assign(new Error('Nimm am besten ein Foto, auf dem dein Kind von vorn und allein zu sehen ist.'), { vomServer: true, foto: true, ohnePerson: true }) }
    messe('foto_ok')
  }

  async function warteAufFotoBefund (marke) {
    const ende = Date.now() + 120000
    while (Date.now() < ende) {
      await new Promise(r => setTimeout(r, 3000))
      const j = await holeAuftrag(state.jobId)
      if (j && j.photoCheckMarke === marke) {
        return { usable: Boolean(j.photoCheck) && j.state !== 'created', ohnePerson: j.ohnePerson, hint: j.photoCheck && j.photoCheck.hint_de, jobId: j.id }
      }
    }
    throw new Error('Das Foto ist nicht bei uns angekommen.')
  }

  // Poster zeichnen lassen. Ohne Serverantwort nachfragen. Ein neues Poster
  // gibt es nur mit neuem Foto (Paul 27.10., wie in der Buchstrecke): Das
  // gleiche Foto ergibt fast dasselbe Bild, der Knopf fuers Neuzeichnen entfaellt.
  async function posterHolen () {
    const bekannt = state.poster ? (state.poster.posterVarianten || []).length : 0
    try {
      return await api('/api/jobs/' + encodeURIComponent(state.jobId) + '/poster-vorschau', {
        json: { neu: false, bekannteVarianten: bekannt, turnstileToken: state.turnstileToken, meta: metaKennungen() }
      })
    } catch (err) {
      if (err.vomServer) throw err
      return warteAufPoster(bekannt)
    }
  }

  async function warteAufPoster (bekannt) {
    const ende = Date.now() + 5 * 60000
    while (Date.now() < ende) {
      await new Promise(r => setTimeout(r, 3000))
      const j = await holeAuftrag(state.jobId)
      if (j && (j.posterVarianten || []).length > bekannt && !j.posterLaeuft) return j
    }
    throw Object.assign(new Error('Das Poster braucht gerade länger als sonst. Bitte versuch es gleich noch einmal.'), { vomServer: true })
  }

  async function posterErstellen () {
    state.laeuft = true
    fehler('foto', '')
    state.fotoFehler = null
    warteBeginnt({ von: 0, bis: 19, sekunden: 8 })
    try {
      await auftragAnlegen()
      await fotoHochladen()
      state.fotoGeprueft = true
      warteBeginnt({ von: 20, bis: 98, sekunden: 18 }) // kleine Vorschau seit 28.10.2026, gemessen 14 bis 17 s
      const p = await posterHolen()
      warteEndet()
      zeigePoster(p)
      messe('vorschau')
    } catch (err) {
      if (!err.vomServer) {
        messe('vorschau_fehler', { grund: 'netz' })
        zeigeAbbruch()
      } else {
        warteEndet({ voll: false })
        if (err.foto) {
          state.fotoFehler = { titel: err.ohnePerson ? 'Auf diesem Foto finden wir kein Gesicht.' : 'Dieses Foto passt leider nicht.', text: err.message }
          zeigeFoto()
        } else {
          fehler('foto', err.message)
          messe('vorschau_fehler', { grund: 'server' })
        }
        zeigeSchritt('foto')
        // Das Token ist nach einem Versuch verbraucht: neu pruefen lassen.
        if (window.turnstile?.reset) { try { window.turnstile.reset('#wpf-turnstile') } catch {} state.turnstileToken = null }
      }
    } finally {
      state.laeuft = false
      zeichneStepper()
      pruefeKnopf()
    }
  }

  function zeigePoster (p, { schritt = 'vorschau' } = {}) {
    state.poster = p
    state.gewaehlt = p.posterNr
    merken()
    const vs = p.posterVarianten || []
    $('#wpf-vorschau-titel').textContent = posterVon()
    // Zwei Versionen gibt es nur noch aus Auftraegen vor dem 27.10.
    $('#wpf-vorschau-satz').textContent = vs.length > 1
      ? 'Du hast zwei Versionen. Tippe auf die, die dir besser gefällt.'
      : 'So sieht ' + (vorname() || 'dein Kind') + ' auf dem Poster aus.'
    const img = $('#wpf-poster')
    img.src = bildUrl(p.posterUrl)
    img.alt = 'Poster mit ' + (vorname() || 'deinem Kind')
    const box = $('#wpf-varianten')
    box.hidden = vs.length < 2
    box.innerHTML = vs.map(v => `<button type="button" class="wpf-v${v.nr === state.gewaehlt ? ' aktiv' : ''}" data-nr="${v.nr}" aria-pressed="${v.nr === state.gewaehlt}"><span class="wpf-v-bild"><img src="${esc(bildUrl(v.url))}" alt=""></span><span class="wpf-v-name">Version ${v.nr}</span></button>`).join('')
    groesseZeigen()
    zeigeSchritt(schritt)
  }

  const gewaehltesBild = () => (state.poster ? bildUrl((state.poster.posterVarianten || []).find(v => v.nr === state.gewaehlt)?.url || state.poster.posterUrl) : D.bild)

  // Groessen als Karten mit maßstaeblichem Umriss, gefuellt mit dem Poster.
  function zeigeGroessen () {
    const bild = gewaehltesBild()
    $('#wpf-groessen').innerHTML = varianten.map(v => {
      const an = state.variante && v.id === state.variante.id
      const [b, h] = UMRISS[formatVon(v)]
      return `<button type="button" role="radio" aria-checked="${an}" class="wpf-g${an ? ' aktiv' : ''}" data-groesse="${v.id}">
        <span class="wpf-g-feld"><span class="wpf-g-umriss" style="width:${b}px;height:${h}px">${bild ? `<img src="${esc(bild)}" alt="">` : ''}</span></span>
        <span class="wpf-g-text"><b>${esc(v.titel)}</b><span>${euro(v.preisZahl)}</span></span>
      </button>`
    }).join('')
  }

  function zeigeRahmenwahl () {
    const block = $('#wpf-rahmenblock')
    const farben = Object.keys(FARBEN).filter(f => rahmenFuer(f))
    block.hidden = !farben.length
    if (!farben.length) { state.rahmen = null; return }
    if (state.rahmen && !rahmenFuer(state.rahmen)) state.rahmen = null
    const karte = (farbe, name, preis) => {
      const an = (state.rahmen || null) === farbe
      return `<button type="button" role="radio" aria-checked="${an}" class="wpf-r${an ? ' aktiv' : ''}" data-rahmen="${farbe || ''}">
        <span class="wpf-r-muster${farbe ? '' : ' ohne'}" style="${farbe ? '--ton:' + FARBEN[farbe].ton : ''}"></span>
        <span class="wpf-r-text"><b>${esc(name)}</b><span>${esc(preis)}</span></span>
      </button>`
    }
    $('#wpf-rahmenwahl').innerHTML = karte(null, 'Ohne Rahmen', 'nur das Poster') + farben.map(f => karte(f, FARBEN[f].name, '+ ' + euro(rahmenFuer(f).preisZahl))).join('')
  }

  function groesseZeigen () {
    const f = formatVon(state.variante)
    const rahmen = $('#wpf-rahmen')
    rahmen.classList.toggle('g50', f === '50x70')
    const rv = rahmenFuer(state.rahmen)
    rahmen.classList.toggle('mit-rahmen', Boolean(rv))
    rahmen.style.setProperty('--ton', rv ? FARBEN[rv.farbe].ton : '#fff')
    const bild = gewaehltesBild()
    if (bild) $('#wpf-wandbild').src = bild
    $('#wpf-wandbild').alt = 'Poster mit ' + (vorname() || 'deinem Kind')
    $('#wpf-wand-text').textContent = (state.variante ? state.variante.titel : '') + (rv ? ' · Rahmen ' + FARBEN[rv.farbe].name : '')
    zeigeGroessen()
    zeigeRahmenwahl()
    zeigeAngaben()
    pruefeKnopf()
  }

  async function variantWaehlen (nr) {
    state.gewaehlt = nr
    const v = (state.poster.posterVarianten || []).find(x => x.nr === nr)
    if (v) $('#wpf-poster').src = bildUrl(v.url)
    wurzel.querySelectorAll('.wpf-v').forEach(b => { const an = Number(b.dataset.nr) === nr; b.classList.toggle('aktiv', an); b.setAttribute('aria-pressed', String(an)) })
    groesseZeigen()
    merken()
  }

  // ------------------------------------------------------------ Kasse
  async function inDenWarenkorb () {
    if (!state.variante || !state.jobId) return
    state.laeuft = true
    pruefeKnopf()
    knopf.textContent = 'Einen Moment ...'
    fehler('vorschau', '')
    try {
      // Welche Variante gekauft wird, steht am Auftrag; der Druck nimmt sie.
      await api('/api/jobs/' + encodeURIComponent(state.jobId) + '/poster-waehlen', { json: { nr: state.gewaehlt } })
      const eigenschaften = { _jobId: state.jobId, _ausgabe: 'poster', _posterNr: String(state.gewaehlt), Name: vorname(), Motiv: D.karte || D.titel }
      const rv = rahmenFuer(state.rahmen)
      // Rahmen als eigene Position mit derselben Auftrags-Id (extractJobs: _ausgabe rahmen).
      const positionen = [{ id: state.variante.id, quantity: 1, properties: eigenschaften }]
      if (rv) positionen.push({ id: rv.id, quantity: 1, properties: { _jobId: state.jobId, _ausgabe: 'rahmen', Name: vorname() } })
      if (D.testKasse) {
        // Lokale Probe (public/poster.html): kein Shopify-Warenkorb.
        window.wunoloPosterKorb = positionen[0]
        window.wunoloPosterKorbAlle = positionen
        knopf.textContent = 'Im Testkorb'
        messe('warenkorb', { ausgabe: 'poster' })
        return
      }
      // Dasselbe Poster nicht doppelt im Korb (zurueck aus der Kasse, andere Groesse oder Rahmen)
      const korb = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json()).catch(() => null)
      for (const z of (korb && korb.items) || []) {
        if (z.properties && z.properties._jobId === state.jobId) {
          await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: z.key, quantity: 0 }) }).catch(() => {})
        }
      }
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: positionen }) })
      if (!res.ok) throw new Error('Der Warenkorb hat gerade nicht geantwortet. Bitte versuch es noch einmal.')
      messe('warenkorb', { ausgabe: 'poster' })
      try {
        fetch(BACKEND + '/api/jobs/' + encodeURIComponent(state.jobId) + '/warenkorb', { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: '{}', keepalive: true }).catch(() => {})
      } catch {}
      location.href = '/checkout'
    } catch (err) {
      fehler('vorschau', err.message || 'Das hat nicht geklappt. Bitte versuch es noch einmal.')
      state.laeuft = false
      pruefeKnopf()
    }
  }

  // ------------------------------------------------------------ Ereignisse
  function waehle (gruppe, attr, wert) {
    wurzel.querySelectorAll(gruppe + ' .choice').forEach(b => b.setAttribute('aria-pressed', String(b.dataset[attr] === wert)))
  }
  $('#wpf-name').addEventListener('input', e => { state.name = e.target.value; merken(); zeigeAngaben(); pruefeKnopf() })
  $('#wpf-mail').addEventListener('input', e => { state.mail = e.target.value; merken() })
  $('#wpf-ok').addEventListener('change', e => { state.einwilligung = e.target.checked; pruefeKnopf() })
  $('#wpf-zf-schalter').addEventListener('click', () => {
    const offen = $('#wpf-zf-koerper').classList.toggle('offen')
    $('#wpf-zf-schalter').setAttribute('aria-expanded', String(offen))
  })
  $('#wpf-datei').addEventListener('change', e => {
    const f = e.target.files && e.target.files[0]
    if (!f) return
    state.foto = f
    if (state.fotoUrl) URL.revokeObjectURL(state.fotoUrl)
    state.fotoUrl = URL.createObjectURL(f)
    // Neues Foto: ein vorhandenes Poster gehoert zum alten Kind.
    state.poster = null
    state.gewaehlt = null
    state.fotoFehler = null
    state.fotoGeprueft = false
    e.target.value = ''
    fehler('foto', '')
    zeigeFoto()
    zeigeAngaben()
    pruefeKnopf()
  })
  wurzel.addEventListener('click', e => {
    const ziel = e.target.closest ? e.target : null
    if (!ziel) return
    if (ziel.closest('[data-foto]')) { $('#wpf-datei').click(); return }
    const ge = ziel.closest('[data-gender]')
    if (ge) { state.gender = ge.dataset.gender; waehle('#wpf-gender', 'gender', state.gender); merken(); zeigeAngaben(); pruefeKnopf(); return }
    const al = ziel.closest('[data-alter]')
    if (al) { state.ageRange = al.dataset.alter; waehle('#wpf-alter', 'alter', state.ageRange); merken(); zeigeAngaben(); pruefeKnopf(); return }
    const g = ziel.closest('[data-groesse]')
    if (g) {
      state.variante = varianten.find(v => v.id === Number(g.dataset.groesse)) || state.variante
      state.groesseGewaehlt = true
      groesseZeigen()
      merken()
      return
    }
    const r = ziel.closest('[data-rahmen]')
    if (r) {
      state.rahmen = r.dataset.rahmen || null
      groesseZeigen()
      merken()
      return
    }
    const b = ziel.closest('.wpf-v')
    if (b) { variantWaehlen(Number(b.dataset.nr)); return }
    const s = ziel.closest('.fk-schritt[data-zustand="erledigt"]')
    if (s && !s.disabled) zurueckZu(s.dataset.ziel)
  })
  // Neues Poster nur mit neuem Foto: zurueck in Schritt 1 und gleich die
  // Fotoauswahl oeffnen (im selben Klick, sonst blockt das Telefon sie).
  $('#wpf-anderes-foto').addEventListener('click', () => {
    if (state.laeuft) return
    $('#wpf-datei').click()
    zurueckZu('foto')
  })
  knopf.addEventListener('click', () => {
    if (state.laeuft) return
    if (state.schritt === 'warten' && state.abbruch) posterErstellen()
    else if (state.schritt === 'foto' && state.poster) zeigeSchritt('vorschau')
    else if (state.schritt === 'foto') posterErstellen()
    else if (state.schritt === 'vorschau') { state.groesseGewaehlt = true; groesseZeigen(); zeigeSchritt('bestellen') }
    else if (state.schritt === 'bestellen') inDenWarenkorb()
  })
  function zumFoto () {
    zeigeSchritt('foto', { verlauf: false })
    fehler('vorschau', '')
    // Das Token der ersten Vorschau ist verbraucht; ein neues Foto braucht ein neues.
    if (turnstileGestartet && window.turnstile?.reset) { try { window.turnstile.reset('#wpf-turnstile') } catch {} state.turnstileToken = null }
    initTurnstile()
    zeigeFoto()
    pruefeKnopf()
  }
  // Zurueck ueber den Verlauf, wenn die Eintraege von uns stammen; so bleiben
  // Stepper, Zurueck-Knopf und Wischgeste in derselben Reihenfolge.
  function zurueckZu (ziel) {
    const weit = schrittNr(state.schritt) - schrittNr(ziel)
    if (weit <= 0) return
    if (history.state && history.state.wpf === state.schritt) history.go(-weit)
    else if (ziel === 'foto') zumFoto()
    else zeigeSchritt(ziel, { verlauf: false })
  }
  window.addEventListener('popstate', e => {
    if (state.laeuft) return
    const ziel = e.state && e.state.wpf
    if ((ziel === 'vorschau' || ziel === 'bestellen') && state.poster) {
      if (ziel === 'bestellen') state.groesseGewaehlt = true
      zeigeSchritt(ziel, { verlauf: false })
    }
    else if (state.schritt === 'vorschau' || state.schritt === 'bestellen') zumFoto()
  })
  // Zurueck aus der Kasse: Seite kommt aus dem Verlauf, Knopf wieder frei.
  window.addEventListener('pageshow', e => { if (e.persisted) { state.laeuft = false; pruefeKnopf() } })

  // ------------------------------------------------------------ Start
  function angabenEinsetzen (alt, j) {
    const p = (j && j.profile) || {}
    state.name = alt.name || p.name || ''
    state.gender = GESCHLECHT[alt.gender] ? alt.gender : GESCHLECHT[p.gender] ? p.gender : null
    state.ageRange = ALTER.some(a => a[1] === alt.ageRange) ? alt.ageRange : ALTER.some(a => a[1] === p.ageRange) ? p.ageRange : null
    state.mail = alt.mail || ''
    $('#wpf-name').value = state.name
    $('#wpf-mail').value = state.mail
    waehle('#wpf-gender', 'gender', state.gender)
    waehle('#wpf-alter', 'alter', state.ageRange)
  }
  async function wiederherstellen () {
    let alt = null
    try { alt = JSON.parse(sessionStorage.getItem(SPEICHER) || 'null') } catch {}
    // Link aus der Poster-Erinnerung (27.10., Flow "Poster gesichert"):
    // ?poster=<Token> fuehrt direkt zum fertigen Poster, wie ?figur= im Buch.
    const linkToken = new URLSearchParams(location.search).get('poster')
    if (linkToken) {
      const d = await fetch(BACKEND + '/api/poster-link/' + encodeURIComponent(linkToken), { cache: 'no-store' }).then(r => (r.ok ? r.json() : null)).catch(() => null)
      if (d && d.jobId && (!alt || alt.jobId !== d.jobId)) alt = { jobId: d.jobId }
    }
    if (!alt) return false
    if (!alt.jobId) { angabenEinsetzen(alt, null); return false }
    const j = await holeAuftrag(alt.jobId)
    // Schon gekauft (Rueckkehr nach der Kasse im selben Tab): neu anfangen,
    // der alte Auftrag nimmt keine Wahl und kein neues Bild mehr an.
    if (!j || !j.posterUrl || j.posterMotiv !== D.motiv || !['created', 'photo_ready'].includes(j.state)) {
      try { sessionStorage.removeItem(SPEICHER) } catch {}
      return false
    }
    state.jobId = j.id
    angabenEinsetzen(alt, j)
    const v = varianten.find(x => x.id === alt.variante)
    if (v && !startId) { state.variante = v; state.groesseGewaehlt = true }
    if (alt.rahmen && FARBEN[alt.rahmen]) state.rahmen = alt.rahmen
    zeigePoster(j)
    if (alt.gewaehlt && alt.gewaehlt !== j.posterNr) variantWaehlen(alt.gewaehlt)
    return true
  }

  zeigeFoto()
  messe('schritt1')
  wiederherstellen().then(da => {
    if (!da) { zeigeSchritt('foto', { verlauf: false }); initTurnstile() }
  })
})()
